import {RealityCheckDialogPresenterBase} from "./reality-check-dialog-presenter-base";
import {IShowRealityCheckOptions} from "./reality-check-presenter.interface";
import {IModalDialogHandler} from "../../../dialog/dialog.service.interface";
import {UserController_GetRealityCheckDataResponse} from "../../../api/api.service";
import {IRealityCheckAnalytics} from "../handlers/reality-check-handler.interface";
import {ShowTimeSpentReminderWithBalanceOptions} from "../../../specific-dialogs/specific-dialogs.service.interface";

export abstract class TimeSpentReminderWithBalancePresenter extends RealityCheckDialogPresenterBase {
    protected async _showDialog(options: IShowRealityCheckOptions, onDialogClosed: () => void): Promise<IModalDialogHandler> {
        const realityCheckData = await this._getRealityCheckData(options);
        const timeSpentReminderOptions = await this._createTimeSpentReminderWithBalanceOptions(realityCheckData, onDialogClosed);
        return this.services.specificDialogs.showTimeSpentReminderWithBalance(timeSpentReminderOptions);
    }

    protected async _createTimeSpentReminderWithBalanceOptions(realityCheckData: UserController_GetRealityCheckDataResponse, onDialogClosed: () => void): Promise<ShowTimeSpentReminderWithBalanceOptions> {
        return {
            totalNetLoss: realityCheckData?.TotalNetLoss ?? 0,
            onDialogClosed: onDialogClosed
        }
    }

    protected _onGetRealityCheckDataSuccess(realityCheckData: UserController_GetRealityCheckDataResponse, analyticsWriter: IRealityCheckAnalytics): void {

    }

    protected _onGetRealityCheckDataFailed(error: any, analyticsWriter: IRealityCheckAnalytics): void {

    }

    private async _getRealityCheckData(options: IShowRealityCheckOptions): Promise<UserController_GetRealityCheckDataResponse> {

        try {
            const response = await this.services.api.userController.getRealityCheckData();
            if(response.ErrorDescription) {
                this._onGetRealityCheckDataFailed(response.ErrorDescription, options.analytics);
            } else {
                this._onGetRealityCheckDataSuccess(response, options.analytics);
            }

            return response;
        } catch (err) {
            this.services.logger.error(`Failed to get reality check data`, err);
            this._onGetRealityCheckDataFailed(err, options.analytics);
            return {
                TotalNetLoss: 0,
                WagerAmount: null,
                ErrorDescription: ""
            }
        }
    }



}